module.exports = __webpack_public_path__ + "static/media/DesignYourCV.faa3059a.PNG";